import { Link } from "react-router-dom";
import { comics } from "@/mocks/comics";
import { homepageSections } from "@/mocks/comics";
import { getComicById } from "@/mocks/comics";
import { categories } from "@/mocks/categories";

function getCategoryName(slug: string): string {
  const cat = categories.find((c) => c.slug === slug);
  return cat ? cat.name : slug;
}

export default function LatestUpdates() {
  const updateIds = homepageSections.latestUpdates;
  const latestComics = updateIds.map((id) => getComicById(id)).filter(Boolean);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            最新更新
          </h2>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-600 flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            更多新作 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
          {latestComics.map((comic) => (
            comic && (
              <Link
                key={comic.id}
                to={`/article/${comic.id}`}
                className="flex gap-3 p-3 rounded-lg bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 group cursor-pointer"
              >
                <div className="w-16 h-20 md:w-20 md:h-28 flex-shrink-0 rounded-md overflow-hidden">
                  <img
                    src={comic.cover}
                    alt={comic.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex flex-col justify-between min-w-0 flex-1">
                  <div>
                    <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-1">
                      {comic.title}
                    </h3>
                    <p className="text-xs text-foreground-500">{comic.author}</p>
                  </div>
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded-full">
                      {getCategoryName(comic.category)}
                    </span>
                    <span className="text-xs text-foreground-400">{comic.updateTime}</span>
                  </div>
                </div>
              </Link>
            )
          ))}
        </div>
      </div>
    </section>
  );
}